var map = {
	"./../channels/channels.module": [
		"./src/app/channels/channels.module.ts",
		"default~channels-channels-module~dashboard-dashboard-module~users-users-module",
		"common",
		"channels-channels-module"
	],
	"./../users/users.module": [
		"./src/app/users/users.module.ts",
		"default~channels-channels-module~dashboard-dashboard-module~users-users-module",
		"users-users-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~channels-channels-module~dashboard-dashboard-module~users-users-module",
		"common",
		"dashboard-dashboard-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;